export { scoreBand } from "@brutally/shared";

export function prettyHost(url: string): string {
  try {
    const u = new URL(url.startsWith("http") ? url : "https://" + url);
    return u.host.replace(/^www\./, "");
  } catch {
    return url;
  }
}

export function makeSiteId(url: string): string {
  return prettyHost(url).replace(/[^a-z0-9]/gi, "-").toLowerCase() + "-" + Math.random().toString(36).slice(2, 6);
}

export function shortDate(d = new Date()): string {
  return d.toLocaleDateString("en-US", { month: "short", day: "2-digit" });
}
